import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'rp',
    description:
      'Monitor and measure performance at every level of your research enterprise.',
    icon: 'rp',
    name: 'Research Performance',
    scenarioVariables: [],
    sessionVariables: [
      {
        defaultValue: 'MTDC',
        id: 'financialVolume',
        name: 'Financial Volume',
        type: {
          inlineEnum: {
            entries: [
              {
                id: 'MTDC',
                name: 'MTDC',
              },
              {
                id: 'TDC',
                name: 'TDC',
              },
            ],
            // NOTE: - We have to do the casing here because the dynamodb does
            // not support class instances. This way, the transformer will take
            // care of the instantiation.
          } satisfies core.common.value.types.Enum.constructor.Params as unknown as core.common.value.types.Enum,
        },
      },
      {
        defaultValue: {
          $range: {
            end: { $date: '12/31/2024' },
            start: { $date: '1/1/2024' },
          },
        },
        id: 'focusedRange',
        name: 'Focused Range',
        type: core.common.value.types.Intrinsic.DateRange,
      },
      {
        id: 'spaceType',
        name: 'Space Type',
        type: {
          dimensionId: 'dim::!room_types',
          isMultiselect: true,
        },
      },
      {
        id: 'researchType',
        name: 'Research Type',
        type: {
          enumId: 'enum::!research_type',
          isMultiselect: true,
        },
      },
    ],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
